export default __webpack_public_path__ + "static/media/img-legal-1-l-en.22a6d43c.png";